import { init, BrowserTracing, ErrorBoundary } from '@sentry/react';

export const ERROR_TYPE_API = 'api';
export const ERROR_TYPE_UI = 'ui';

export function initSentry() {
  init({
    dsn: 'https://d15ac02981a04fb19de9b9d0a65da386@o1407395.ingest.sentry.io/4505048133992448',
    release: __VERSION__,
    integrations: [new BrowserTracing()],
    environment: __RELEASE_STAGE__,
    tracesSampleRate: 1.0,
  });
}

export function getSentryErrorBoundary() {
  return ErrorBoundary;
}
